import React, { useState, useEffect } from 'react';
import { Icon } from '../../components/Icon';
import { useDebounce } from '../../hooks/useDebounce';
import { Table } from './Table';
// import { LeadFormCard } from '../../components/LeadFormCard';
import { useContacts } from '../../hooks/useContacts';

const Contacts: React.FC = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm] = useState('');
    //   const [showFilters, setShowFilters] = useState(false);
    const [personType] = useState("");
    const debouncedSearch = useDebounce(searchTerm, 300);
    // const [showLeadForm, setShowLeadForm] = useState(false);

    // const handleOpenForm = () => {
    //     setShowLeadForm(prev => !prev);
    // };

    // const handleCloseForm = () => {
    //     setShowLeadForm(false);
    // };

    const {
        data: contacts,
        loading,
        error,
        total,
        totalPages,
        refetch,
        // creating
    } = useContacts({
        tipo_persona_id: personType,
        page: currentPage,
        pageSize
    });

    // Reset page when search or filters change
    useEffect(() => {
        setCurrentPage(1);
    }, [debouncedSearch]);

    // const handleSearchPage = () => {
    //     setCurrentPage(1);
    //     search(searchTerm, typeTerm);
    // }

    //   const handleFilterChange = (newFilters: Partial<EmpleadoFilters>) => {
    //     setFilters(prev => ({ ...prev, ...newFilters }));
    //   };

    // const clearFilters = () => {
    //   setFilters({});
    //   setSearchTerm('');
    //   setShowFilters(false);
    // };

    if (error) {
        return (
            <div className="space-y-6 animate-fade-in">
                <div className="flex items-center justify-between">
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                        Contactos
                    </h2>
                </div>
                <div className="card p-6 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800">
                    <div className="flex items-center">
                        <Icon name="alert-circle" className="w-5 h-5 text-red-500 mr-2" />
                        <span className="text-red-700 dark:text-red-300">
                            Error: {error}
                        </span>
                    </div>
                    <button
                        onClick={refetch}
                        className="mt-3 btn-primary"
                    >
                        Reintentar
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="space-y-6 animate-fade-in">
            {/* Header */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0">
                <div>
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                        Contactos
                    </h2>
                    <p className="text-gray-600 dark:text-gray-400 mt-1">
                        {total} contactos encontrados
                    </p>
                </div>
                {/* <div className="flex items-center space-x-3">
                    <button
                        onClick={handleOpenForm}
                        className={`flex items-center px-4 py-2 text-sm font-medium text-white ${showLeadForm ? "bg-red-400 hover:bg-red-500" : "bg-blue-600 hover:bg-blue-700"}  rounded-lg  transition-colors`}
                    >
                        {showLeadForm ? (
                            <>
                                <Icon name="close" className="w-4 h-4 mr-2" />
                                Cancelar
                            </>
                        ) : (
                            <>
                                <Icon name="plus" className="w-4 h-4 mr-2" />
                                Nuevo Contacto
                            </>
                        )}
                    </button>
                </div> */}
            </div>





            {/* Componente hijo - Card del formulario */}
            {/* <LeadFormCard
                creating= {creating}
                isVisible= {showLeadForm}
                onClose= {handleCloseForm}
                onSubmit= {createLead}
            /> */}

            {/* Filtros y búsqueda */}
            {/* <div className="card p-6">
                <div className="flex flex-row space-x-2 lg:flex-row lg:items-center lg:justify-start space-y-4 lg:space-y-0">

                    <div className="flex-1 max-w-md">
                        <div className="relative">
                            <Icon name="search" className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                            <input
                                type="text"
                                placeholder="Buscar por nombre..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                            />
                        </div>
                    </div>
                    <div className="flex-1 max-w-md">
                        <div className="relative">
                            <Icon name="chevron-down" className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4 pointer-events-none" />
                            <select
                                value={typeTerm}
                                onChange={(e) => setTypeTerm(e.target.value)}
                                className="w-full pl-4 pr-10 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white appearance-none"
                            >
                                <option value="">Todos</option>
                                <option value="1">Programado</option>
                                <option value="2">Recurrente</option>
                                <option value="3">No Programada</option>
                            </select>
                        </div>
                    </div>
                    <div>
                        <button
                            // onClick={handleSearchPage}
                            className={`flex items-center mx-auto px-3 py-2 border dark:hover:bg-gray-700 dark:bg-gray-600 dark:text-white border-gray-500 text-sm font-medium rounded-lg transition-colors`}
                        >
                            <Icon name="search" className="w-4 h-4 mr-1" />
                            Buscar
                        </button>
                    </div>
                </div>
            </div> */}

            <Table
                data={contacts}
                loading={loading}
                currentPage={currentPage}
                totalPages={totalPages}
                pageSize={pageSize}
                total={total}
                onPageChange={setCurrentPage}
                onRefresh={refetch}
            />
        </div>
    );
};

export default Contacts;